define('areas/navigationmanager/commands/removegroupcommand',["require", "exports"], function (require, exports) {
    "use strict";
    var RemoveGroupCommand = (function () {
        function RemoveGroupCommand(process) {
            this._removeGroup = process;
        }
        RemoveGroupCommand.prototype.execute = function (symbol) {
            this._removeGroup.process(symbol);
        };
        return RemoveGroupCommand;
    }());
    return RemoveGroupCommand;
});

